
import { ApplicantRequest } from './../model/applicantRequestModel';
import { ApplicantSearchRequest } from './../model/applicantSearchRequestModel';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {PaymentModel} from '../model/payment.model';
import {DocumentSearchModel} from '../shared/dto/document-search.model';
import {DocumentTypeModel} from '../shared/dto/document-type.model';
import {InventoryModel} from '../shared/dto/inventory.model';
import {AppConfig} from '../shared/common/app.config';

@Injectable({
  providedIn: 'root'
})
export class ApplicantRequestService {
  private headers;

  constructor(private http: HttpClient, private appConfig: AppConfig) { }

  baseUrl: string =  this.appConfig.getConfig('BASE_URL') + 'api/applicant/';

  search(data: ApplicantSearchRequest): Observable<ApplicantRequest> {
    return this.http.post<ApplicantRequest>(this.baseUrl + 'getApplicantPendingRequest', data);
  }

  getApplicantDetails(id: number) {
    return this.http.get<ApplicantRequest>(this.baseUrl + 'getApplicant/' + id );
  }

  editApplicantDetails(data: ApplicantRequest) {
    return this.http.post<ApplicantRequest>(this.baseUrl + 'editApplicant', data);
  }

  uploadFiles(file) {
    return this.http.post<ApplicantRequest>(this.baseUrl + 'uploadFile', file);
  }

  uploadPrintedSIDFiles(formData: FormData) {

    return this.http.post(this.baseUrl + 'uploadSIDFiles', formData);
  }

  deleteFile(id: number) {
    return this.http.get<ApplicantRequest>(this.baseUrl + 'deleteFile/' + id);
  }

  searchPaymentPendingData(paymentModel:PaymentModel): Observable<Object> {
    return this.http.post(this.baseUrl + 'paymentPendingApplicants' , paymentModel, {headers: this.headers});
  }

  searchApplicant(paymentRefNo: number): Observable<Object> {
    return this.http.get(this.baseUrl + 'getApplicantByPayRef/' + paymentRefNo );
  }

  paymentRequestDetailsByRequestId(RequestNo: number): Observable<Object> {
    return this.http.get(this.baseUrl + 'getApplicantByRef/' + RequestNo );
  }

  proceedPayment(paymentRefNo: number): Observable<Object> {
    return this.http.post(this.baseUrl + 'proceedPayment' , paymentRefNo, {responseType: 'text'});
  }

  printPaymentReceipt(paymentRefNo: number): Observable<object> {
    return this.http.post(this.baseUrl + 'printPaymentReceipt', paymentRefNo, {responseType: 'arraybuffer'});
  }

  savePaymentDetails(data: any): Observable<any> {
    return this.http.post(this.baseUrl + 'updatePaymentDetails', data);
  }

  searchApplicantHistory(applicationId: number) {
    return this.http.get(this.baseUrl + 'getRequestHistory/' + applicationId );
  }

  dataEntryRejectRequest(applicationId: number, appType: string, remark: string, userName: string){
    return this.http.get(this.baseUrl + 'dataEntryReject/' + applicationId + '/' + appType + '/' + remark + '/' + userName);
  }

  getDocumentType(applicationId: number): Observable<object> {
    return this.http.get(this.appConfig.getConfig('BASE_URL') +'api/document/getSavedDocType/' + applicationId );
  }

  getRejectStatusList(): Observable<object>{
    return this.http.get(this.baseUrl+'getRejectStatus/')
  }

  deleteDocumentType(docType: DocumentTypeModel): Observable<object> {
    return this.http.post(this.appConfig.getConfig('BASE_URL') +'api/document/deleteDocType/' , docType );
  }

  getAllDocumentType(details: DocumentSearchModel): Observable<object> {
    return this.http.post(this.appConfig.getConfig('BASE_URL') +'api/document/getSavedDocTypes/', details);
  }

  cardPreview(applicationId: number): Observable<object> {

    return this.http.post(this.baseUrl + 'cardPreview', applicationId, {responseType: 'arraybuffer'});
  }

  cardPreview1(applicationId: any): Observable<object> {
    return this.http.post(this.baseUrl + 'cardPreview1', applicationId, {responseType: 'arraybuffer'});
  }

  getAllDistrict(): Observable<Object> {
    return this.http.get(this.appConfig.getConfig('BASE_URL') + 'api/location/getAllDistrict/' , {headers: this.headers});
  }

  findSidByDistrict(district: string) {
    return this.http.get(this.baseUrl + 'getSidByDistrict/' +district, {headers: this.headers});
  }
  paymentDetailsByApplicantId(id: any): Observable<Object> {
    return this.http.get(this.baseUrl + 'getPaymentDetailsByApplicant/' + id );
  }

  printApplicantPaymentReceipt(paymentRefNo: number): Observable<object> {
    return this.http.post(this.baseUrl + 'printApplicantPaymentReceipt', paymentRefNo, {responseType: 'arraybuffer'});
  }

  // returnRequest(approvalModel: ApprovalModel): Observable<Object> {
  //   return this.httpClient.post(this.baseUrl + 'revered-blacklist/returnRequest', approvalModel, {headers: this.headers});
  // }

  saveInventory(data: any): Observable<any> {
    return this.http.post(this.appConfig.getConfig('BASE_URL') + 'api/inventory/save', data);
  }

  searchInventory() {
    return this.http.get(this.appConfig.getConfig('BASE_URL') + 'api/inventory/all' );
  }

  deleteInventory(id: any, remark: any): Observable<any> {
    return this.http.post(this.appConfig.getConfig('BASE_URL') + 'api/inventory/delete', {id:id, remark:remark});
  }

  returnInventory(id: any): Observable<any> {
    return this.http.post(this.appConfig.getConfig('BASE_URL') + 'api/inventory/return', id);
  }

  searchInventoryByPara(model:InventoryModel) {
    console.log(model);
    return this.http.post(this.appConfig.getConfig('BASE_URL') + 'api/inventory/search', model );
  }

  cardViewDoc(mod: DocumentTypeModel): Observable<object> {
    return this.http.post(this.appConfig.getConfig('BASE_URL') + 'api/document/docPreview', mod, {responseType: 'arraybuffer'});
  }

}
